import { FC } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import {
  AI_LISTENING_BRAND_NEW_ROUTE,
  AI_LISTENING_BRAND_PROFILE_ROUTE,
} from 'src/constants/routes'
import { useAiListeningLink } from 'src/hooks/useAiListeningDateRange'
import { useResolvedBrandProfile } from '../shared/hooks'
import { AiListeningPage, PageBreadcrumb, PageTitleRow } from '../shared/Layout'
import { ProfileTabs } from '../shared/ProfileHeader'
import { StateCard } from '../shared/StateCard'

// /ai-listening/brand: the brand profile last viewed (or the first one), or
// the "No Brand Profile Added Yet" state.
export const BrandProfileLanding: FC = () => {
  const navigate = useNavigate()
  const link = useAiListeningLink()
  const { isError, isLoading, profile, refetch } = useResolvedBrandProfile()

  if (isLoading) return null

  if (profile) {
    return (
      <Navigate
        replace
        to={link(AI_LISTENING_BRAND_PROFILE_ROUTE, { profileId: profile._id })}
      />
    )
  }

  return (
    <AiListeningPage>
      <PageBreadcrumb items={['AI Listening', 'Brand Profiles']} />
      <PageTitleRow title="Your Brand AI Visibility">
        <ProfileTabs active="brand" />
      </PageTitleRow>
      {isError ? (
        <StateCard
          action={{ label: 'Try again', onClick: () => refetch() }}
          description="Your brand profiles could not be loaded. Check your connection and try again."
          icon="processing"
          title="Something went wrong"
        />
      ) : (
        <StateCard
          action={{
            label: 'Add Your Brand',
            onClick: () => navigate(link(AI_LISTENING_BRAND_NEW_ROUTE)),
          }}
          description={
            <>
              Add your brand to see how it appears in ChatGPT, Gemini,
              Perplexity and Claude,
              <br />
              and start tracking your AI visibility.
            </>
          }
          icon="brand"
          title="No Brand Profile Added Yet"
        />
      )}
    </AiListeningPage>
  )
}
